/**
 * Countdown offer bar on product cards — see snippets/pcard-offer.liquid.
 * Collection pages can be cached, so the server-rendered countdown may be stale:
 * this keeps the text current and shows/hides each bar at its start/end time.
 * One shared timer drives every bar on the page (incl. cards added by filters/load more).
 */
(() => {
  if (customElements.get('pcard-offer')) return;

  const instances = new Set();
  let timer = null;

  const format = (seconds) => {
    const days = Math.floor(seconds / 86400);
    const hours = Math.floor((seconds % 86400) / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    if (days > 0) return `${days}d ${hours}h`;
    if (hours > 0) return `${hours}h ${minutes}m`;
    return `${Math.max(minutes, 1)}m`;
  };

  const tick = () => instances.forEach((offer) => offer.update());

  class PcardOffer extends HTMLElement {
    connectedCallback() {
      this.start = Number(this.dataset.start) || 0;
      this.end = Number(this.dataset.end) || 0;
      this.countdown = this.querySelector('[data-offer-countdown]');
      instances.add(this);
      this.update();
      if (!timer) timer = setInterval(tick, 30000);
    }

    disconnectedCallback() {
      instances.delete(this);
      if (!instances.size && timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    update() {
      const now = Date.now() / 1000;
      if (now >= this.end) {
        this.remove();
        return;
      }
      this.hidden = now < this.start;
      if (this.countdown) this.countdown.textContent = format(this.end - now);
    }
  }

  customElements.define('pcard-offer', PcardOffer);
})();
